export function toFlatJson(formData) {
  return Object.fromEntries(
    Object.entries(formData).map(([key, value]) =>
      [
        key, 
        value !== null 
        && typeof value === 'object' 
        && value.hasOwnProperty('value') ? value.value : value
      ]
    )
  );
}

export function valueToOption (value, options, callback) {
  let option;

  if (typeof value !== 'object' && value !== undefined && value !== null) {
    option = options.find(opt => opt.value === value);
  }

  if (option) {
    callback(option);
  }
};